"use client";

import type { FlowsDemoBlock } from "@mw/shared/payload-types";
import dynamic from "next/dynamic";

const BlockFlowsDemo = dynamic(() => import("./BlockFlowsDemo").then(mod => mod.BlockFlowsDemo));

export default function BlockFlowsDemoWrapper(props: FlowsDemoBlock) {
  return <BlockFlowsDemo {...props} />;
}
